var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "wrapper box" }, [
        _c("div", [
          _c("h1", [_vm._v("用户隐私保护政策")]),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { "line-height": "1", "text-align": "right" } },
            [_vm._v("更新日期：2021年11月12日")]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { "line-height": "1", "text-align": "right" } },
            [_vm._v("生效日期：2021年11月12日")]
          ),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              引言\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              '欢迎使用"北京职业教育智慧教育在线学习平台" 提供的产品和服务！国家职业教育智慧教育平台（或简称“我们”）由高等教育出版社有限公司提供运营和服务。在此声明，我们十分重视用户隐私，隐私权是您重要的权利。您在使用我们提供的服务过程中，我们可能会通过多种方式收集和使用您的相关信息，包括通过您的自愿提交、注册登录、上传资源、浏览资源等活动，以及通过"Cookies" 和其他追踪技术等。本《隐私政策》与您所使用的国家职业教育智慧教育平台服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本隐私政策中所涉及到的相关技术词汇，我们会尽量以简明扼要的表述，以方便您的理解。'
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们希望通过本《隐私政策》向您说明我们在收集和使用您相关个人信息时对应的处理规则，以及我们为您提供的访问、更正、删除和保护这些个人信息的方式，以便更好的保障您的权益。如果您不同意本隐私政策任何内容，您应立即停止使用国家职业教育智慧教育平台产品或服务。当您使用国家职业教育智慧教育平台提供的任一服务时，即表示您已同意我们按照本隐私政策来合法使用和保护您的个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _c("strong", [_vm._v("相关术语及定义")]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1．高教社：指高等教育出版社有限公司享有所有权或运营权的主体及其关联公司。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2．个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括个人基本资料（姓名、出生日期）、个人身份信息（身份证、军官证、护照、工作证）、个人生物识别信息（个人基因、指纹）、网络身份标识信息（系统账号、IP地址、邮箱地址及前述有关的密码、口令、口令保护答案）、个人健康生理信息、个人教育工作信息（个人职业、职位、工作单位、学历、学位、教育经历）、个人财产信息（银行账号、存款信息、交易和消费记录、财产信息、征信信息）、个人通信信息（通信通讯联系方式、通信记录和内容）、联系人信息（通讯录、好友列表、群列表）、个人上网记录（指通过日志存储的用户操作记录）、个人常用设备记录（包括硬件序列号、设备MAC地址、软件列表、唯一设备识别码）、个人位置信息（包括行踪轨迹、精准定位信息、住宿信息等）其他信息（婚史、宗教信息、性取向、未公开的违法犯罪记录等）。本定义出自于GB/T 35273-2017《信息安全技术个人信息安全规范》。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "3．个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括个人财产信息（银行账号、鉴别信息、交易和消费记录、流水记录等）、个人生物识别信息、个人身份信息（如身份证、军官证、护照、工作证）、网络身份标识信息（如系统账号、邮箱地址及前述有关的密码、口令、口令保护答案）、其他信息（个人电话号码、性取向、婚史、行踪轨迹、网页浏览记录、精确定位信息）等。本定义出自于GB/T 35273-2017《信息安全技术个人信息安全规范》。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "4．收集：指获得对个人信息的控制权的行为，包括由个人信息主体主动提供、通过与个人信息主体交互或记录个人信息主体行为等自动采集，以及通过共享、转让、搜集公开信息间接获取等方式。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "5．删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "7．转让：指将个人信息控制权由一个控制者向另一个控制者转移的过程。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "8．共享：指个人信息控制者向其他控制者提供个人信息，且双方分别对个人信息拥有独立控制权的过程。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "9．去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "10．关联公司：指相互之间存在关联关系的公司，关联关系是指公司控股股东、实际控制人、董事、监事、高级管理人员与其直接或者间接控制的企业之间的关系，以及可能导致公司利益转移的其他关系。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              一、我们可能获得您的个人信息\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1.您提供的个人信息。您在注册国家职业教育智慧教育平台服务的帐号或使用国家职业教育智慧教育平台服务时，向我们所提供的个人信息；您通过国家职业教育智慧教育平台服务向其他方提供的共享个人信息，以及您使用国家职业教育智慧教育平台服务时所储存的个人信息（例如电话号码、电子邮件等）。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2.其他方分享的您的个人信息。亦即您通过我们的服务向第三方提供的共享信息，以及您使用我们的服务时所储存的信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "3.我们获取的您的个人信息。您在使用国家职业教育智慧教育平台服务时，我们收集、汇总、记录的个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              二、我们会出于以下目的，收集和使用您以下类型的个人信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("1．帮助您完成注册、登录及注销"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "为便于我们为您提供国家职业教育智慧教育平台完整的服务，您需要提供基本注册或登录个人信息，包括手机号码、电子邮箱地址，并创建您的账号、用户名和密码。在部分单项服务中，如果您仅需使用浏览、查询、搜索等基本服务，您不需要注册成为国家职业教育智慧教育平台用户及提供上述个人信息。 在国家职业教育智慧教育平台部分单项服务注册、登录或后续使用过程中，如果您提供其他额外个人信息（包括您的昵称、头像、您的学习阶段、学习目标、您所处阶段或所属年级），将有助于我们给您提供个性化的推荐和更优的服务体验，但如果您不提供这些个人信息，并不会影响您使用国家职业教育智慧教育平台的基本功能。 如果您不再使用国家职业教育智慧教育平台，在符合服务协议约定条件及国家相关法律法规规定的情况下，我们也提供注册账号的注销，您可以通过本《隐私政策》第十五条【如何联系我们】约定的联系方式或各单项服务的具体指引进行操作。当您的帐号注销或被删除后，与该帐号相关的国家职业教育智慧教育平台项下的全部服务资料和数据最迟将在一周内删除处理，但法律法规另有规定的除外。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("2．维护基础功能的正常运行"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "在您使用我们服务过程中，为识别账号异常状态、了解产品适配性，向您提供浏览、搜索等基本服务，维护基础功能的正常运行，我们可能会自动收集、储存关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （1）日志信息：当您使用我们的服务时，我们可能会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。日志信息包括您的登录账号、搜索查询内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、Push打开记录、崩溃记录、停留时长、刷新记录、发布记录、关注、订阅、收藏及分享。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （2）设备信息：我们可能会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（包括IMEI、MAC、Serial、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、进程及软件列表、唯一设备标识符、软硬件特征信息）、设备所在位置相关信息（包括IP 地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器信息）。 同时为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将可能导致您无法使用我们的产品与服务。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做去标识化处理。这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("3．向您提供商品或服务"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （1）个人信息的分享与发布：您在使用国家职业教育智慧教育平台时、上传和/或发布个人信息以及进行相关行为（例如您在国家职业教育智慧教育平台部分服务中输入的文字、相关课程内活班级内的发言、分享、进行作业、自测时输入的文字）时，我们将收集您上传、发布或形成的个人信息，并有权展示您的昵称、头像和发布内容。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （2）客服与售后服务：当您联系我们的客服或使用其他用户响应功能时（包括提出使用中的问题、个人信息保护投诉或建议、其他客户投诉和需求），我们可能需要您提供必要的个人信息以匹配并核验您的用户身份，以便保障您的账号与系统安全。我们可能还会保存您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、您与我们的通信/通话记录和内容、与您需求相关联的其他必要信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("4．我们通过间接方式收集到的您的个人信息："),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们可能从第三方合作伙伴获取您授权共享的相关个人信息。我们可能从第三方获取您授权共享的账户个人信息（头像、昵称、登录时间）并在您同意本《隐私政策》后将您的第三方账户与您的国家职业教育智慧教育平台账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的个人信息来源合法的前提下，收集并使用您的这些个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("5．向您提供商品或服务的信息展示和推送"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （1）为您展示和推送商品或服务"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "基于您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息（包括您的浏览及搜索记录、设备信息、位置信息、订单信息、手机号码、您参与国家职业教育智慧教育平台线上或线下活动填写问卷调查上的个人信息），我们可能会基于上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向您提供更契合您需求的页面展示和推荐个性化内容。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （2）向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。 如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息；但我们依法律规定或单项服务的服务协议约定发送消息的情形除外。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("6．为您提供安全保障"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "为提高您使用我们及合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或国家职业教育智慧教育平台相关协议规则的情况，我们可能会收集、使用或整合您的账户信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的个人信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("7．辅助平台为用户提供深度服务"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "为了更好地呈现我们的网站和内容，同时保障服务的正常运行以及账号安全，在您了解并同意后，我们将按照合法、正当、必要的原则收集您的个人信息，并通过技术手段对数据进行去标识化处理。去标识化处理的个人信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的个人信息，对用户数据进行分析并予以商业化的利用。我们可能将通过上述收集到的个人信息用于我们的其他服务：维护平台的正常运行，确保我们向您提供的产品和服务的安全性，让您参与有关国家职业教育智慧教育平台的调查，以及实现特定功能所需的您提供的个人信息等。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [_vm._v("8．其他用途")]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "请您注意，如果我们要将您的个人信息用于本《隐私政策》中未载明的其他用途或额外收集未提及的其他个人信息，我们会另行事先请您同意（确认同意的方式：勾选、弹窗、站内信、邮件、短信方式）。一旦您同意，该等额外用途将视为本《隐私政策》的一部分，该等额外个人信息也将适用本《隐私政策》。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("9．征得授权同意的例外"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （1）与国家安全、国防安全有关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （2）与公共安全、公共卫生、重大公共利益有关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （3）与犯罪侦查、起诉、审判和判决执行等有关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （5）所收集的个人信息是您自行向社会公众公开的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （7）根据您的要求签订合同所必需的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （8）用于维护国家职业教育智慧教育平台的安全稳定运行所必需的，例如发现、处置产品或服务的故障；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （9）为合法的新闻报道所必需的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" （11）法律法规规定的其他情形。"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "10．您理解并同意，国家职业教育智慧教育平台可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及个人信息的收集和使用："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （1）如我们访问您的位置信息，是为了根据您的位置信息为您提供更契合您需求的页面展示和产品服务；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （2）如我们访问您的摄像头，是为了使您可以使用摄像头进行扫码、拍摄，用于实现登录、支付、图片评论、拍照取词、上传课程作业/资料、观看视频、直播互动及拍照翻译功能；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （3）如我们访问您的相册，是为了使您可以实现您设备中的照片、图片或视频的取用与上传，便于您进行更换头像、发表评论/分享；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （4）如我们访问您的麦克风，是为了使您可以实现语音翻译功能、语音评论、与客服实现语音交互以及语音教学交互功能，在这些功能中我们会收集您的录音内容以识别您的具体需求；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " （5）您使用国家职业教育智慧教育平台中的单项服务，可能会生成视频缓存文件，我们会申请访问该视频缓存文件，是为了使您更为流畅的体验我们的课程服务或为您提供课程离线观看功能。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的个人信息收集及使用。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              三、我们所获取的您的个人信息\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "在为您提供服务时，我们可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户，或者无法享受我们提供的某些服务，也无法达到相关服务拟达到的效果。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1.您向我们提供的信息。您在注册账户时，向我们提供的相关个人信息，例如电话号码、姓名、任教学校等；我们还会记录您在使用我们服务时提供的信息，例如您在国家职业教育智慧教育平台客户端发布、上传的信息、与国家职业教育智慧教育平台客服联系时您提供的相关信息、您参与问卷调查时向我们发送的问卷答复信息等。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _c("strong", [
              _vm._v(
                "还请您注意，您在使用我们服务时自愿发布甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。因此请您在使用我们的服务时更加谨慎地考虑，是否要发布甚至公开分享相关信息。"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2.在您使用服务过程中产生的信息。我们会根据您授予的权限，接收并记录您所使用的设备相关信息，这些设备信息包括：设备属性信息（如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备位置信息（如通过GPS、蓝牙或WIFI信号获得的位置信息）、设备连接信息（IP地址、电信运营商、使用的语言、访问日期和时间等）。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "3.来自第三方的信息。当您与使用我们服务的关联公司、国家职业教育智慧教育平台合作伙伴之间互动时，为共同向您提供服务及改进服务质量的合理需要，我们将从关联公司、合作伙伴处接收关于您的体验或您与其互动的信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _c("strong", [
              _vm._v(
                "这里需提醒，单独的日志信息、设备以及位置信息是无法识别特定自然人身份的信息。如若将这类非个人信息与其他信息结合来识别其自然人身份，甚至是与个人信息进行结合使用，那么在此使用期间被视作个人信息，除非您本人进行授权外，我们在此期间，将这些信息作为您个人信息按照隐私政策保护与处理。"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              四、我们可能使用何种方法收集您的个人信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们或我们的第三方合作伙伴，可能通过cookie和web beacon收集和使用您的信息，并将该等信息储存为日志信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们使用自己的cookie和web beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " (1)记住您的身份。例如：cookie和web beacon有助于我们辨认您作为我们的用户的身份，或保存您向我们提供的有关您的喜好或其他信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " (2)分析您使用我们服务的情况。例如，我们可利用cookie和web beacon来了解您使用我们的服务进行什么活动，或哪些服务最受您的欢迎。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " (3)广告优化。Cookie和web beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 我们为上述目的使用cookie和web beacon的同时，可能将通过cookie和web beacon收集的非个人身份信息，经统计加工（以便该等信息不会识别到您个人）后提供给合作广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 我们的产品和服务上可能会有合作广告商或其他合作方放置的cookie和web beacon。这些cookie和web beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookie和web beacon收集和使用该等信息，不受本隐私政策约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookie或web beacon承担责任。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 您可以通过终端设备设置拒绝或管理cookie或web beacon。但请注意，如果停用cookie或web beacon，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到广告，但这些广告与您的相关性会降低。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" 我们如何使用Cookie和同类技术："),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [_vm._v("  （1）Cookie")]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 使用 Cookie 能帮助您实现您的联机体验的个性化，您可以接受或拒绝 Cookie ，大多数 Web 浏览器会自动接受 Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookie。为了让您在访问国家职业教育智慧教育平台时能得到更好的服务，国家职业教育智慧教育平台有时会使用 Cookie 以便知道哪些网站受欢迎。Cookie不会跟踪个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 当您注册国家职业教育智慧教育平台时，国家职业教育智慧教育平台亦会使用 Cookie。在这种情况下，国家职业教育智慧教育平台会收集并存储有用信息，当您再次访问国家职业教育智慧教育平台时，我们可辨认您的身份。来自国家职业教育智慧教育平台的 Cookie 只能被国家职业教育智慧教育平台读取。如果您的浏览器被设置为拒绝 Cookie，您仍然能够访问国家职业教育智慧教育平台的大多数网页。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("  （2） 网站信标和像素标签"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("  (3）Do Not Track(请勿追踪)"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not Track 请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了 Do Not Track，那么我们的产品和服务都会尊重您的选择。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              五、我们可能如何使用您的个人信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。我们可能将在向您提供服务的过程之中所收集您的个人信息用作以下用途："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 1.根据教育行政部门或研究机构要求，收集或推送的用以评估资源应用和在线教学绩效的相关应用数据；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" 2.确保我们的网站和内容以最好的方式呈现给您；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 3.在我们提供服务的同时，为您提供您希望我们提供的信息、产品或服务，或在您允许的情况下，向您推荐您可能感兴趣或者需要的内容；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 4.在我们提供服务时，用于个人身份验证、客户服务、安全防范、诈骗监测以及存档和备份用途，确保我们向您提供的产品和服务的安全性；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" 5.改进我们的产品与服务所必须的功能；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" 6.邀请您参与我们服务有关的用户调研；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" 7.根据法律法规或监管要求向相关部门进行报告；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(" 8.软件认证或管理软件升级。"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              " 我们可以使用您的个人数据，或者允许我们所选定的第三方关联公司使用您的个人数据，以向您提供您可能会感兴趣的产品以及服务的信息。我们或他们可能以邮件、信息或电话的方式与您联系。这是基于我们，或是我们合作伙伴，可以向您提供关于我们或他们的产品和服务的信息的合法权益。如您不希望接收上述信息，可通过《隐私政策》最下方约定的联系方式联系我们。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              六、我们如何共享、转让、公开披露您的个人信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们充分知晓因违法共享、转让、公开披露个人信息对个人信息主体造成损害时所应承担的法律责任，对于您的个人信息的一切共享、转让、公开披露，我们将严格按照以下条款进行："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [_vm._v("(一) 共享")]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "尊重用户个人隐私是国家职业教育智慧教育平台的一项基本原则。除以下情形外，我们不会与任何公司、组织和个人分享您的个人信息："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1．在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2．我们可能会按照司法机关或行政机关的要求，对外共享您的个人信息；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "3．与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些产品与/或服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供产品与/或服务所必要的个人信息，并对我们与之共享个人信息的公司、组织和个人签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("目前，我们的合作伙伴包括："),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "合作的第三方SDK服务商：当您使用APP中由第三方提供的功能时，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关功能。具体包括如下："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "A. 地理位置服务：为给您提供位置服务（包括定位、购票和同城服务），第三方地理位置服务商高德SDK会收集您的设备信息及地理位置信息以便可以向您推送附近内容的服务；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "B. 数据统计功能：我们会使用友盟SDK以准确记录App的活跃情况、设备信息、网络相关信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "C. 消息推送：为给您提供及时的消息推送，第三方推送服务商可能会获取您必要设备信息、手机状态信息、地理位置信息、网络相关信息以便推送您可能更感兴趣的信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "D. 其它功能：如App崩溃统计，我们使用了Bugly、Crashlytics 等，相关功能可能会获取您的设备信息和网络相关信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [_vm._v("(二) 转让")]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1．在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2．在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [_vm._v("(三) 公开披露")]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "除了因国家职业教育智慧教育平台维护需要，对违规账号、欺诈、辱骂等严重损害国家职业教育智慧教育平台的行为进行处罚公告（如公布被处罚账号的主页链接），或者公布中奖/获胜者名单时展示相关信息等必要事宜而进行必要披露之外，我们仅会在获得您明确同意后，公开披露您的个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(四) 共享、转让、公开披露个人信息授权同意的例外情形"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "根据法律法规的规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("1．与我们履行法律法规规定的义务相关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("2．与国家安全、国防安全直接相关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("3．与公共安全、公共卫生、重大公共利益直接相关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("4．与刑事侦查、起诉、审判和判决执行等直接相关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "5．出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("6．您自行向社会公众公开的个人信息；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "7．从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              七、我们如何保护您的个人信息安全\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们为您的信息提供相应的安全保障，以确保不出现信息的丢失、不当使用、未经授权访问或披露的情况。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1.根据相关法律法规，我们会严格保护用户的信息秘密。我们会适应符合业界标准的安全防护措施来保障用户信息安全，以防止发生数据信息遭到未被授权访问、使用、修改、损坏或丢失等情况。我们会采取一切合理可行的措施，保护您的个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2.我们会使用合理且在安全范围内的安全保护技术（如加密技术、匿名化处理技术）以保障您个人信息的安全。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "3.同时我们会建立专门的管理流程与轮值组织制度以确保信息安全。保证平台对网络与信息安全事件做到快速觉察、快速应对、及时处理、及时恢复。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "4.制定信息安全事件应急方案。建立健全网络与信息安全管理预案，加强对网站网络信息的日常监测、监控，强化安全管理，对可能引发网络与信息安全事件的有关信息，认真收集、分析判断，发现有异常情况时，及时处理并逐级报告。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "如果您对我们的个人信息保护有任何疑问，可通过《隐私政策》最下方约定的联系方式联系我们。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              八、您如何访问和控制自己的个人信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "无论您何时使用国家职业教育智慧教育平台的相关产品与/或服务，我们都会尽一切可能保证您可以顺利访问自己的账户信息。如果这些信息有误，我们会努力提供各种方式来让您快速更新或删除账户内信息。为了使您拥有充分的能力保障您的隐私和安全，您拥有如下权利："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(一) 访问您的个人信息"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "除司法机关或行政机关另有要求外，您有权随时访问您的个人信息。包括以下信息："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [_vm._v("1．账户信息：")]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "如果您希望访问或编辑您的账户中的名号/昵称、头像、登录邮箱、手机号、隐私设置等，可以通过访问国家职业教育智慧教育平台的个人中心执行此类操作。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [_vm._v("2．使用信息：")]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "您可以在相关产品页面随时查阅您的课程使用信息，如成绩单，学习日志等。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "如果您无法通过上述链接及方式访问，您可以随时联系我们，我们将尽快回复您的请求。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(二) 更正您的个人信息"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "当您发现您所填写的或者我们处理的关于您的个人信息有错误时，您有权自行更正。当您无法自行更正时，您可以随时联系我们，我们将尽快回复您的更正请求。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(三) 删除您的个人信息"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "您有权随时自行删除或者联系我们删除您的个人信息。在以下情形中，您可以向我们提出删除个人信息的请求："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("1．我们处理个人信息的行为违反法律法规的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("2．我们收集、使用您的个人信息，却未征得您的同意；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("3．我们处理个人信息的行为违反了与您的约定；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("4．您不再使用我们的产品或服务，或您注销了账号；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("4．您不再使用我们的产品或服务，或您注销了账号；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("5．我们不再为您提供产品或服务。"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "若我们决定响应您的删除请求，我们还将同时通知以合作方从国家职业教育智慧教育平台获得您的个人信息的实体，要求其及时删除，除非这些实体另行获得您的独立授权。但请知悉，若您在国家职业教育智慧教育平台或产品的公开信息被其它用户或与我们没有合作、关联以及不受我们控制的独立第三方抓取、缓存、储存、复制，或通过其它用户在其它网站上传、保存时，相关信息将不受高教社的控制。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "当您从我们的服务中删除您的个人信息后，我们也会从备份系统中删除相应的信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "如因经营不善等原因，我们停止运营了，我们会立即停止对您对应个人信息的收集，并删除已收集的个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("如您遇到无法删除的情况，请通过icve@hep.com.cn联系我们。"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(四) 改变您授权同意的范围或撤回您的授权"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "每个业务功能需要一些基本的个人信息才能得以完成(见本政策“第一部分”)。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以通过删除信息、关闭移动设备对应功能（如使用iOS系统用户可通过“设置”-“隐私”-[hep icve]从而改变或撤回对我们访问您的位置、照片、相机等的授权，如android系统用户可通过“设置”-“应用”-“管理权限” 从而改变或撤回相应授权）等方式改变您授权同意的范围或撤回您的授权。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(五) 注销／删除账号"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "您可以选择注销/删除国家职业教育智慧教育平台账号，账号注销/删除后将不可恢复，您的个人信息与课程数据将会被立刻删除，平台将终止对您提供的各种服务，建议您自行做好备份工作。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "如您遇到无法注销账号的情况，可以按照本《隐私政策》提供的方式联系我们。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(六) 获取您的个人信息副本"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们将根据您的书面请求，为您提供以下类型的个人信息副本：您的个人基本资料、个人身份信息。但请注意，我们为您提供的信息副本仅以我们收集的信息为限。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(七) 约束信息系统自动决策"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("(八) 响应您的上述请求"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们将在十五个工作日内做出答复。如您不满意，还可以通过以下途径投诉：发送邮件到icve@hep.com.cn。 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段(例如，需要开发新系统或从根本上改变现行惯例)、给他人合法权益带来风险或者非常不切实际(例如，涉及备份磁带上存放的信息)的请求，我们可能会予以拒绝。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("在以下情形中，按照法律法规要求，我们将无法响应您的请求："),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("1．与个人信息控制者履行法律法规规定的义务相关的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("2．与国家安全、国防安全直接相关的;"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("3．与公共安全、公共卫生、重大公共利益直接相关的;"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("4．与刑事侦查、起诉、审判和判决执行等直接相关的;"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("5．有充分证据表明您存在主观恶意或滥用权利的;"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "6．响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的;"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "7．出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("8．涉及商业秘密的。"),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              九、您个人信息的存储\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们将从中华人民共和国境内获得的信息存放于中华人民共和国境内。 如果发生数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。 我们承诺您个人信息的存储时间始终处于合理必要期限内。 在仅浏览功能下所收集的个人信息如浏览记录、IP 信息，我们的存储期限不会超过12个月 。对于超出期限的个人信息，我们会立即删除处理。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "如我们因经营不善或其他原因出现停止运营的情况，我们会立即停止对您个人信息的收集，删除已收集的个人信息。 我们会将此情况在网站上进行公告或以站内信、邮件等其他合理方式逐一传达到各个用户。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              十、我们可能向您发送的邮件和信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "您在使用我们的服务时，我们可能使用您的信息向您的设备推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消推送。我们还可能在必要情况下，向您发出服务有关的公告，此类公告不属于推广的公告，您可能无法取消。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              十一、信息安全\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息，除非需要延长保留期或受到法律的允许。为了实现APP的各项正常功能，对于人脸照片数据，我们会在收集您的数据后存储90天，到期自动删除。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "互联网并非百分百绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。同时我们将竭尽全力防止信息的丢失、不当使用、未经授权阅览或披露。如若真的发生个人信息安全事件，我们将依照相关法律法规要求，及时通过邮件、短信、电话、推送通知等方式向您进行告知。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "为实现产品和服务相关功能，我们可能需要您授权我们使用您终端设备中的相关权限，包括但不限于："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "麦克风权限，以便在录制语音、发布通知等功能中采集您的声音；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "相机权限，以便在拍照上传资源、布置作业、考试随机抓拍、摄像头监测等功能中采集所需图像；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("相册权限，以便在上传资源、头像等功能中采集相关图片；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("存储权限，以便存储应用的图片和音频文件，节省您的流量；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("位置权限，以便教师和学生正常开启使用位置签到的功能；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "通讯录权限，允许应用获取本机号码、通知状态以及拨打的号码，以便在教学过程、学习过程以及教学管理过程中可以方便师生间拨打电话联系。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "通知权限，允许修改应用中的设置项，显示弹窗、全屏界面到其他应用上面，以便用户及时获取应用信息；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("通话权限，以便联系客服，解决问题。"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("短信权限，以便注册登录时读取验证码，快捷注册登录。"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "请您注意，大多数移动设备都允许您关闭上述权限提供服务，具体方法建议您参考或联系您移动设备的服务商或生产商，一旦您通过系统授权关闭上述权限功能，您将可能无法使用我们基于相关信息提供的服务，或者无法达到相关服务的预期效果。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              十二、我们如何保护您分享的敏感个人信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "对比于其他个人信息，一些用户由于其信息的特殊性，可能被认为是敏感信息。根据《信息安全技术个人信息安全规范》（GB/T 35273—2017），个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息、14岁以下（含）未成年人的个人信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "同时提醒，您在使用我们提供服务的时候，可能会泄露一些您的敏感个人信息，您需慎重考虑，是否继续使用我们提供的相关服务时披露您的敏感个人信息。您同意按照本《隐私政策》所述的目的和方式来处理您的敏感个人信息。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n              十三、我们如何保护未成年人的信息\n          "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1.我们十分重视对未成年人信息的保护。如果您是未满18周岁的未成年人，您的监护人需要仔细阅读本政策并授权您同意依照本政策使用平台。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2.如果您是未成年用户的父母或监护人，当您对您所监护的未成年人的信息处理存在疑问时，您可通过本《隐私政策》中的联系方式联系我们。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "3.我们将根据国家相关法律法规的规定保护未成年人的信息的保密性及安全性。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              十四、隐私政策的适用范围\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "本政策适用于所有国家职业教育智慧教育平台提供的相关产品或服务，包括web、PC客户端、APP端等版本产品及服务。一些产品与服务存在其特定的隐私政策与服务，如本政策与特定服务的隐私条款存在不一致之处，以本《隐私政策》为准。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _c("strong", [
              _vm._v("着重说明，本《隐私政策》不适用于以下情况："),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "1.您使用该等第三方服务须受其隐私政策（而非本《隐私政策》）约束，您需要仔细阅读其政策内容。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "2.本政策不适用由其他公司或个人提供的服务（不论该服务是否通过国家职业教育智慧教育平台提供）。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "3.还请您仔细阅读该第三方服务提供者的相应隐私政策，以便保护您的合法权益。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              十五、修订和通知\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "我们的隐私政策可能修订与变更，未经您明确同意，我们不会削减您按照本《隐私政策》所应享有的权利。如这些修订造成您在本《隐私政策》下权利的实质减少，我们会在产品或服务的显著位置或推送通知或向您发送电子邮件或其他合适的方式通知您。如果您在新修订隐私政策和服务条款生效后继续使用国家职业教育智慧教育平台服务，即表示您已充分了解并愿意接受修订后的隐私政策和服务条款约束。"
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n              十六、如何联系我们\n          "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v(
              "如果对本《隐私政策》或相关事宜有任何问题，请通过以下联系方式与我们联系。"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("邮箱：icve@hep.com.cn"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _vm._v("通讯地址：北京市朝阳区惠新东桥4号富盛大厦1座19层"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copy-article" }, [
            _c("strong", [
              _vm._v("我们会对您提出的问题，妥善并及时进行处理。"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }